import React, { useState } from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Box,
    Paper,
    useMediaQuery,
    Button,
    Fab,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import KeyboardVoiceOutlinedIcon from '@mui/icons-material/KeyboardVoiceOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import CloseIcon from '@mui/icons-material/Close';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import UserInfo from './userInfo';
import Notepad from './notepad';

const UserSection = ({ updateUserDetail, setAudioModalShow, setModalShow_call, setModalShow_temp, setUserInfoFormEnable, userInfoFormEnable, setShowChatBox, showChatBox }) => {
    const [expanded, setExpanded] = useState(false);
    const [subExpanded, setSubExpanded] = useState(false);
    const isMobile = useMediaQuery('(max-width:600px)');
    const [showIcons, setShowIcons] = useState(false);


    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleSubChange = (panel) => (event, isExpanded) => {
        setSubExpanded(isExpanded ? panel : false);
    };

    const transcript = [
        {
            sender: 'Person 2',
            message: 'Okay, I’ll forward this to the IT team and update you soon.',
        },
        {
            sender: 'Person 4',
            message: 'Thanks, please let me know once it’s resolved.',
        },
        {
            sender: 'Person 1',
            message: 'Sure, will do.',
        },
    ];

    return (
        <Box>
            {!isMobile && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 1.5,
                        mb: 1,
                        width: '100%',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 1.5,
                            alignItems: 'center',
                        }}
                    >
                        <KeyboardVoiceOutlinedIcon
                            sx={{ cursor: 'pointer' }}
                            color="primary"
                            onClick={() => setAudioModalShow(true)}
                        />
                        <LocalPhoneOutlinedIcon
                            sx={{ cursor: 'pointer' }}
                            color="primary"
                            onClick={() => setModalShow_call(true)}
                        />
                        <SendOutlinedIcon
                            sx={{ cursor: 'pointer' }}
                            color="primary"
                            onClick={() => setModalShow_temp(true)}
                        />
                        {showChatBox ? (
                            <CloseIcon
                                sx={{ cursor: 'pointer' }}
                                color="primary"
                                onClick={() => setShowChatBox(false)}
                            />
                        ) : (
                            <MessageOutlinedIcon
                                sx={{ cursor: 'pointer' }}
                                color="primary"
                                onClick={() => setShowChatBox(true)}
                            />
                        )}
                    </Box>
                    {/* <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button
                            variant="contained"
                            size="small"
                            disabled={userInfoFormEnable}
                            onClick={updateUserDetail}
                        >
                            Save
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            onClick={() => setUserInfoFormEnable(!userInfoFormEnable)}
                        >
                            Edit
                        </Button>
                    </Box> */}
                </Box>
            )}

            {/* Mobile View - Floating Action Buttons */}
            {isMobile && (
                <>
                    {/* Save/Edit Buttons at top for mobile */}
                    {/* <Box sx={{ display: 'flex', gap: 1, mb: 2, width: '100%', mt: 1 }}>
                        <Button
                            variant="contained"
                            size="small"
                            fullWidth
                            disabled={userInfoFormEnable}
                            onClick={updateUserDetail}
                        >
                            Save
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            fullWidth
                            onClick={() => setUserInfoFormEnable(!userInfoFormEnable)}
                        >
                            Edit
                        </Button>
                    </Box> */}

                    {/* Floating Icons - Bottom Right */}
                    <Box
                        sx={{
                            position: 'fixed',
                            bottom: 70,
                            right: 16,
                            zIndex: 1000,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1,
                        }}
                    >
                        {showIcons && (
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 1 }}>
                                <Fab size="small" color="primary" onClick={() => setAudioModalShow(true)}>
                                    <KeyboardVoiceOutlinedIcon />
                                </Fab>
                                <Fab size="small" color="primary" onClick={() => setModalShow_call(true)}>
                                    <LocalPhoneOutlinedIcon />
                                </Fab>
                                <Fab size="small" color="primary" onClick={() => setModalShow_temp(true)}>
                                    <SendOutlinedIcon />
                                </Fab>
                                <Fab size="small" color="primary" onClick={() => setShowChatBox(!showChatBox)}>
                                    {showChatBox ? <CloseIcon /> : <MessageOutlinedIcon />}
                                </Fab>
                            </Box>
                        )}
                        <Fab color="primary" onClick={() => setShowIcons(!showIcons)}>
                            {showIcons ? <CloseIcon /> : <MoreVertIcon />}
                        </Fab>
                    </Box>
                </>
            )}

            <Accordion
                expanded={expanded === 'summary'}
                onChange={handleChange('summary')}
                style={{
                    border: '1px solid #EAEAEA',
                    borderRadius: '4px 4px 0px 0px',
                    boxShadow: 'none',
                }}
                sx={{
                    '&:before': { background: 'none' },
                }}
            >
                <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: 'secondary.main' }} />}>
                    <Typography
                        variant="subtitle2"
                        sx={{ color: 'secondary.main', fontWeight: 'bold' }}
                    >
                        AI Generated Summary
                    </Typography>
                </AccordionSummary>
                <AccordionDetails className="Accordian-detail-wrapper">
                    {/* SUB-ACCORDIONS INSIDE SUMMARY */}
                    <Accordion
                        expanded={subExpanded === 'shortSummary'}
                        onChange={handleSubChange('shortSummary')}
                        sx={{
                            border: '1px solid #D0D0D0',
                            borderRadius: '6px',
                            mb: 1.5,
                            '&:before': { display: 'none' },
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            sx={{
                                backgroundColor: '#D7DEFF',
                            }}
                        >
                            <Typography variant="body2" fontWeight="bold">
                                Previous Call Summary
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                <li>
                                    <Typography variant="body2">
                                        The user asked the AI for help with editing text and designing visuals.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="body2">
                                        The AI provided clear, step-by-step suggestions and design ideas.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="body2">User asked for small updates.</Typography>
                                </li>
                            </ul>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion
                        expanded={subExpanded === 'detailedSummary'}
                        onChange={handleSubChange('detailedSummary')}
                        sx={{
                            border: '1px solid #D0D0D0',
                            borderRadius: '6px',
                            '&:before': { display: 'none' },
                            mb: 2,
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            sx={{
                                backgroundColor: '#D7DEFF',
                            }}
                        >
                            <Typography variant="body2" fontWeight="bold">
                                Al Suggested Questions on the Behalf of Previous Call
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ul style={{ margin: 0, paddingLeft: '0px' }}>
                                <li>
                                    <Typography variant="body2">
                                        The user asked the AI for help with editing text and designing visuals.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="body2">
                                        The AI provided clear, step-by-step suggestions and design ideas.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="body2">User asked for small updates.</Typography>
                                </li>
                            </ul>
                        </AccordionDetails>
                    </Accordion>
                </AccordionDetails>
            </Accordion>
            <Accordion
                expanded={expanded === 'transcript'}
                onChange={handleChange('transcript')}
                style={{
                    border: '1px solid #EAEAEA',
                    borderRadius: '4px 4px 0px 0px',
                    boxShadow: 'none',
                    background: 'none',
                }}
                sx={{
                    '&:before': { background: 'none' },
                }}
            >
                <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: 'secondary.main' }} />}>
                    <Typography
                        variant="subtitle2"
                        sx={{ color: 'secondary.main', fontWeight: 'bold' }}
                    >
                        Transcript
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1.5,
                            maxHeight: 250,
                            overflowY: 'auto',
                            backgroundColor: '#fafafa',
                            padding: '8px',
                            borderRadius: '8px',
                        }}
                    >
                        {transcript.map((item, index) => (
                            <Box
                                key={index}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <Typography
                                    variant="caption"
                                    sx={{
                                        color: 'secondary.main',
                                        alignSelf: 'flex-end',
                                        fontWeight: 600,
                                        marginLeft: 'auto',
                                    }}
                                >
                                    {item.sender}
                                </Typography>

                                <Paper
                                    elevation={1}
                                    sx={{
                                        backgroundColor: '#fff',
                                        padding: '8px 12px',
                                        borderRadius: '8px',
                                        maxWidth: '80%',
                                        alignSelf: 'flex-end',
                                        boxShadow: '0px 1px 3px rgba(0,0,0,0.1)',
                                    }}
                                >
                                    <Typography variant="body2">{item.message}</Typography>
                                </Paper>
                            </Box>
                        ))}
                    </Box>
                </AccordionDetails>{' '}
            </Accordion>
            {/* <Accordion
                expanded={expanded === 'userInfo'}
                onChange={handleChange('userInfo')}
                style={{
                    border: '1px solid #EAEAEA',
                    borderRadius: '4px 4px 0px 0px',
                    boxShadow: 'none',
                }}
                sx={{
                    '&:before': { background: 'none' },
                }}
            >
                <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: 'secondary.main' }} />}>
                    <Typography
                        variant="subtitle2"
                        sx={{ color: 'secondary.main', fontWeight: 'bold' }}
                    >
                        {true ? 'Create New User' : 'User information'}{' '}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <UserInfo />
                </AccordionDetails>
            </Accordion> */}

            <Accordion
                expanded={expanded === 'internalComments'}
                onChange={handleChange('internalComments')}
                style={{
                    border: '1px solid #EAEAEA',
                    borderRadius: '4px 4px 0px 0px',
                    boxShadow: 'none',
                }}
                sx={{
                    '&:before': { background: 'none' },
                }}
            >
                <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: 'secondary.main' }} />}>
                    <Typography
                        variant="subtitle2"
                        sx={{ color: 'secondary.main', fontWeight: 'bold' }}
                    >
                        Internal Comments
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Notepad />
                </AccordionDetails>
            </Accordion>
        </Box>


    );
};

export default UserSection;
